import { Link } from "react-router";
import React from "react";

const SlideItem = ({ item }) => {
  const pressSource = item.title && item.title.split(",")[0];
  return (
    <div className="slide-item" key={item.RowNum}>
      <Link to={item.url} target="_blank">
        <img src={item.mOLogoUrl} alt={`${pressSource} logo`} />
      </Link>
    </div>
  );
};

export default SlideItem;



// WEBPACK FOOTER //
// ./src/components/homepage/press/slide-item.js